import React from 'react';
import Login from '../Login';
type Props = {};
const LoginContainer = ({}: Props) => {
  return <Login />;
};

export default LoginContainer;
